import Configuration from './Configuration';

export function getProfileApiRoot(): string {
  const config = Configuration.Current();
  return `${config.apiRoot}/omni/profile/v2`;
}
